import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';

const EngagementTrendsChart = ({ data = [], loading = false }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date?.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' });
  };

  const formatPercentage = (value) => {
    return `${value}%`;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="TrendingUp" size={24} className="text-primary" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Tendencias de Engagement
        </h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-80">
          <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : data?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-80">
          <Icon name="BarChart3" size={48} className="text-muted-foreground mb-2" />
          <p className="text-sm caption text-muted-foreground">
            No hay datos de tendencia disponibles
          </p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              dataKey="date" 
              tickFormatter={formatDate}
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              tickFormatter={formatPercentage}
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              formatter={(value, name) => {
                const labels = {
                  openRate: 'Tasa de Apertura',
                  clickRate: 'Tasa de Clics',
                  conversionRate: 'Tasa de Conversión'
                };
                return [`${value}%`, labels?.[name] || name];
              }}
              labelFormatter={formatDate}
              contentStyle={{
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '8px 12px'
              }}
            />
            <Legend 
              formatter={(value) => {
                const labels = {
                  openRate: 'Tasa de Apertura',
                  clickRate: 'Tasa de Clics',
                  conversionRate: 'Tasa de Conversión'
                };
                return labels?.[value] || value;
              }}
            />
            <Line 
              type="monotone" 
              dataKey="openRate" 
              stroke="#10b981" 
              strokeWidth={2}
              dot={{ fill: '#10b981', r: 3 }}
              activeDot={{ r: 5 }}
            />
            <Line 
              type="monotone" 
              dataKey="clickRate" 
              stroke="#3b82f6" 
              strokeWidth={2}
              dot={{ fill: '#3b82f6', r: 3 }}
              activeDot={{ r: 5 }}
            />
            <Line 
              type="monotone" 
              dataKey="conversionRate" 
              stroke="#f59e0b" 
              strokeWidth={2}
              dot={{ fill: '#f59e0b', r: 3 }}
              activeDot={{ r: 5 }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default EngagementTrendsChart;